/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLocation
 */
export interface UserLocation {
    /**
     * 
     * @type {number}
     * @memberof UserLocation
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocation
     */
    locationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserLocation
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserLocation
     */
    updatedAt?: Date;
}

export function UserLocationFromJSON(json: any): UserLocation {
    return UserLocationFromJSONTyped(json, false);
}

export function UserLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function UserLocationToJSON(value?: UserLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'locationId': value.locationId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


